var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCloneIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.272 -0.549)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    transform: "translate(0.272 0.549)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.857,7.286H0v-6A1.286,1.286,0,0,1,1.286,0h9.429A1.286,1.286,0,0,1,12,1.286v9.429A1.286,1.286,0,0,1,10.714,12H5.571v-.857h5.143a.429.429,0,0,0,.429-.429V1.286a.429.429,0,0,0-.429-.429H1.286a.429.429,0,0,0-.429.429Z",
    transform: "translate(7.272 2.549)",
    fill: "#0c4767"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.091,2.25H10v5.4A1.357,1.357,0,0,1,8.636,9H1.364A1.357,1.357,0,0,1,0,7.65V1.35A1.357,1.357,0,0,1,1.364,0H6.818V.9H1.364a.452.452,0,0,0-.455.45v6.3a.452.452,0,0,0,.455.45H8.636a.452.452,0,0,0,.455-.45Z",
    transform: "translate(1.272 10.549)",
    fill: "#0c4767"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.223.878H5.579V0H8.644V3.072H7.768V1.582L.651,9.508,0,8.921Z",
    transform: "translate(6.061 6.117)",
    fill: "#fd9926"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloneIcon);
export default __webpack_public_path__ + "static/media/clone_icon.b573374cb310d7501ef6cefe7e330719.svg";
export { ForwardRef as ReactComponent };